import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { ArchivingChecks } from "@reflag/shared/featureAPI";

export function useFeatureArchivingChecks(featureId?: string | null) {
  const { appId, envId } = useEnvironment();

  return useQuery<ArchivingChecks, AxiosError<ErrorResponse>>({
    queryKey: featureQueryKeys.archivingChecks(appId, envId, featureId!),

    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/archiving-checks">(
          `/apps/${appId}/features/${featureId}/archiving-checks`,
          {
            params: {
              envId: envId!,
            },
          },
        )
        .then((res) => res.data),
    enabled: !!appId && !!featureId,
    refetchOnWindowFocus: false,
    retry: false,
    refetchInterval: (query) => {
      if (query.state.status !== "success") {
        return false;
      }

      const checks = query.state.data;
      if (!checks) {
        return false;
      }

      if (!checks.githubIntegrationEnabled || checks.codeRefsScanCompleted) {
        return false;
      }

      // Keep archive checks fresh while waiting for the background code scan.
      return 3000;
    },
  });
}
